// extracted by mini-css-extract-plugin
module.exports = {"control":"StaysCheckoutComplete_control__bNFIy","row":"StaysCheckoutComplete_row__39xj-","col":"StaysCheckoutComplete_col__3Rnf2"};